// extracted by mini-css-extract-plugin
export default {"title":"S3eMzN5O","userCard":"taP2xgwu","userCard__content":"ijPfPENc","userCard__buttons":"eoyrDW7b","formElement":"Po_Bnq42"};
    if(module.hot) {
      // 1776432160784
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  